import { requestHelpers } from '../../helpers';
import { browserHistory } from 'react-router';

const actions = {
    LOGIN_USER: 'LOGIN_USER',
    LOGOUT_USER: 'LOGOUT_USER',
    HAS_ERRORED: 'HAS_ERRORED',
    RESET_PASSWORD: 'RESET_PASSWORD',
    SET_REDIRECT_URL: 'SET_REDIRECT_URL',
    FIRST_LOGIN_TO_BUNDLES_PAGE: "FIRST_LOGIN_TO_BUNDLES_PAGE",
    RESTORE_HEADER: "RESTORE_HEADER",
};

function loginUser() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.LOGIN_USER,
        } );
    };
}

function logoutUser() {
    return dispatch => {
        requestHelpers
            .authenticatedPostRequest( '/authentication/logout' )
            .then( response => {
                localStorage.clear();
                localStorage.setItem('localStorage', 1);
                window.location.href = `${ window.location.origin }/login`;
            });
    };
};

function hasErrored( code ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.HAS_ERRORED,
            code
        } );
    };
}

function resetPassword() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.RESET_PASSWORD,
        } );
    };
}

function getRedirectUrl( redirectUrl, itemId ) {
    return ( dispatch ) => {
        requestHelpers
            .unauthenticatedPostRequest( '/authentication/redirect', { redirect: redirectUrl, item_id: itemId } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_REDIRECT_URL,
                    redirectUrl: response.data,
                } )
            } )
    }
}

function firstLoginBundlesAction() {
    return dispatch => {
        dispatch( {
            type: actions.FIRST_LOGIN_TO_BUNDLES_PAGE,
            isFirstLogin: true,
        } );
    };
}

function restoreHeader() {
    return dispatch => {
        dispatch( {
            type: actions.RESTORE_HEADER,
            restoreHeader: true,
        } );
    };
}

module.exports = {
    actions,
    loginUser,
    logoutUser,
    hasErrored,
    resetPassword,
    getRedirectUrl,
    firstLoginBundlesAction,
    restoreHeader,
};



// WEBPACK FOOTER //
// src/client/actions/authentication/authentication.js